import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "@/App";
import { Navbar } from "@/components/Navbar";
import { HeroSection } from "@/components/HeroSection";
import { TattooStylesMarquee } from "@/components/TattooStylesMarquee";
import { GallerySection } from "@/components/GallerySection";
import { AboutSection } from "@/components/AboutSection";
import { ReviewsSection } from "@/components/ReviewsSection";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";

export default function LandingPage() {
  const [siteSettings, setSiteSettings] = useState(null);

  useEffect(() => {
    axios.get(`${API}/settings/public`).then((res) => setSiteSettings(res.data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-[#050505]" data-testid="landing-page">
      <Navbar />
      <HeroSection settings={siteSettings} />
      <TattooStylesMarquee />
      <GallerySection />
      <AboutSection settings={siteSettings} />
      <ReviewsSection />
      <ContactSection settings={siteSettings} />
      <Footer settings={siteSettings} />
    </div>
  );
}
